import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

export const Header = () => {
  return (
    <Container>
      <Text variant='Body_18_SemiBold' color='textStrong'>
        실측 사이즈
      </Text>
    </Container>
  );
};

export const Container = styled.div`
  padding: 20px 16px;
`;
